export function GetObjectID(dataObject) {
  if (dataObject == null) return null;

  return dataObject.GetObjectID();
}
